import { getCurrentLanguage, t as translate } from '@/i18n/index.js'

export default {
  data() {
    return {
      currentLanguage: getCurrentLanguage()
    }
  },
  methods: {
    handleLanguageChanged(lang) {
      this.currentLanguage = lang
    }
  },
  computed: {
    t() {
      return (key, params) => {
        return this.$t ? this.$t(key, params) : translate(key, params)
      }
    }
  },
  mounted() {
    uni.$on('language-changed', this.handleLanguageChanged)
  },
  unmounted() {
    uni.$off('language-changed', this.handleLanguageChanged)
  }
}
